import type { MealSwap as PopsMealSwap } from '@/types/pops'
import { SakaraClassicMeal } from './sakara-classic-meal'
import type { Meal } from './meal'

export class MealSwap {
  id?: number
  swapFromDay: number
  swapFromMeal: string
  swapToDay?: number
  swapToMeal?: string
  classicMeal?: string
  #swapFromMealCode?: string
  #swapToMealCode?: string

  constructor(rawMealSwap: Partial<PopsMealSwap>) {
    this.id = rawMealSwap.id
    this.swapFromDay = rawMealSwap.swap_from_day as number
    this.swapFromMeal = rawMealSwap.swap_from_meal as string
    this.swapToDay = rawMealSwap.swap_to_day
    this.swapToMeal = rawMealSwap.swap_to_meal
    this.classicMeal = rawMealSwap.classic_meal
  }

  get swapFromMealCode() {
    if (this.#swapFromMealCode) return this.#swapFromMealCode

    this.#swapFromMealCode = MealSwap.getMealCode(
      this.swapFromMeal,
      this.swapFromDay,
    )

    return this.#swapFromMealCode
  }

  get swapToMealCode() {
    if (this.#swapToMealCode) return this.#swapToMealCode

    this.#swapToMealCode = this.classicMeal
      ? this.classicMeal
      : MealSwap.getMealCode(
          this.swapToMeal as string,
          this.swapToDay as number,
        )

    return this.#swapToMealCode
  }

  /**
   *
   * @param {'B'|'L'|'D'} meal Single letter abbreviated meal
   * @param {number} day Day number (1 to 7 => Monday to Sunday)
   */
  static getMealCode(meal: string, day: number) {
    return `${meal}${day}`
  }

  static createMealSwapWithMeals(fromMeal: Meal, toMeal: Meal) {
    if (toMeal instanceof SakaraClassicMeal) {
      return new MealSwap({
        swap_from_meal: fromMeal.mealCode[0],
        swap_from_day: Number(fromMeal.mealCode[1]),
        classic_meal: toMeal.mealCode,
      })
    }

    return new MealSwap({
      swap_from_meal: fromMeal.mealCode[0],
      swap_from_day: Number(fromMeal.mealCode[1]),
      swap_to_meal: toMeal.mealCode[0],
      swap_to_day: Number(toMeal.mealCode[1]),
    })
  }
}

export default MealSwap
